@if (faIcon) {
  <fa-icon
    [icon]="faIcon">
  </fa-icon>
}
